var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.property && _vm.properties.length > 0)?_c('PropertyRentalsPageTab',{attrs:{"property":_vm.property}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }